(function ($) {
    'use strict';

    let timer = null;
    const interval = 250;
    const search = $('input.searching');
    const searchResult = $('#search-result');
    const prefill = searchResult.html();
    
    search.on('keyup', function (e) {
        e.preventDefault();

        clearTimeout(timer);
        const $this = $(this);

        timer = setTimeout(function () {
            inputSearch($this);
        }, interval);
    });

    function inputSearch(input) {
        searchResult.html(prefill);
        const $className = input.data('class');
        const $items = $(input.data('item'));
        const data = {'search': input.val()};

        if (window.request !== undefined) {
            // alert('abbort');
            window.request.abort();
        }

        window.request = $.ajax({
            url: frontUrl +'ajax/'+ $className + '/search?search=' + data.search,
            type: 'GET',
            dataType: 'json',
            success: function (response) {
                if ($className === 'Agenda') {
                    const template = require('../template/agenda/agenda.hbs');
                    const content = template(response);
                    $items.html(content);
                } else if ($className === 'WerkVanKlanten') {
                    const template = require('../template/werkvanklanten/showcase.hbs');
                    const content = template(response);
                    $items.html(content);
                } else {
                    $items.html('<p class="col-12 center">Geen resultaten</p>');
                }

                if (!$items.html().length) $items.html('<p class="col-12 center">Geen resultaten</p>');
            },
            error: function () {
                console.log('SEARCH: ERROR');
            }
        });
    }
})(jQuery);
